import { css } from "styled-components";

export const ctaGradient =
  "linear-gradient(90deg, #0d6ac3 1.6%, rgba(200, 122, 227, 0.99) 55.89%, rgba(253, 145, 1, 0.99) 102.66%)";

export const modalOverlay = css`
  background: rgba(5, 7, 12, 0.68);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
`;